import { useMemo } from 'react'
import { NavLink } from 'react-router-dom'
import clsx from 'clsx'

import { useAuthStore } from '@/store/auth-store'
import { ROUTES } from '@/router'
import { Role } from '@/types/auth'
import { useUpdatedRecordsAvailable } from '@/pages/UnfinishedRecords/hooks/useHaveUpdatedRecords'

import styles from './Navigation.module.scss'

import IndicatorIcon from '../assets/indicator.svg'
import { useGetAllUnfinishedLogsForController } from '@/modules/CombinedLogs/api/useGetAllUnfinishedLogsForController'

export const Navigation = () => {
    const { role } = useAuthStore()
    const { data: unfinishedLogs } = useGetAllUnfinishedLogsForController()
    const haveUpdatedRecords = useUpdatedRecordsAvailable()

    const unfinishedPageLabel = role === Role.MileageClerk ? 'Updated records' : 'Unfinished records'

    const isUnfinishedPageAvailable = role && role !== Role.Reader
    const isAllDisruptionsPageAvailable = role && (role === Role.Reader || role === Role.PerformanceManager)
    const isFlaggedPageAvailable = role && (role === Role.PerformanceManager || role === Role.MileageClerk)

    const isIndicatorVisible = useMemo(() => {
        if (role === Role.Controller) {
            return unfinishedLogs && !!unfinishedLogs.length
        }

        if (role === Role.MileageClerk || role === Role.PerformanceManager) {
            return haveUpdatedRecords
        }

        return false
    }, [role, haveUpdatedRecords, unfinishedLogs])

    return (
        <nav className={styles.root}>
            <NavLink
                to={role === Role.PerformanceManager ? ROUTES.AREAS : ROUTES.HOME}
                className={({ isActive }) => clsx(styles.navItem, { [styles.navItemActive]: isActive })}
            >
                Controller log
            </NavLink>
            {isUnfinishedPageAvailable && (
                <NavLink
                    to={ROUTES.UNFINISHED_RECORDS}
                    className={({ isActive }) => clsx(styles.navItem, { [styles.navItemActive]: isActive })}
                >
                    {unfinishedPageLabel}
                    {isIndicatorVisible && <IndicatorIcon />}
                </NavLink>
            )}

            {isAllDisruptionsPageAvailable && (
                <NavLink
                    to={ROUTES.ALL_DISRUPTIONS}
                    className={({ isActive }) => clsx(styles.navItem, { [styles.navItemActive]: isActive })}
                >
                    Disruptions
                </NavLink>
            )}

            {isFlaggedPageAvailable && (
                <NavLink
                    to={ROUTES.FLAGGED}
                    className={({ isActive }) => clsx(styles.navItem, { [styles.navItemActive]: isActive })}
                >
                    Flagged
                </NavLink>
            )}
        </nav>
    )
}
